import { NOTIFICATION_TYPE } from '../notifications';

export function isAvailableEvent(type) {
  return (
    type === NOTIFICATION_TYPE.MISSION_AVAILABLE ||
    type === NOTIFICATION_TYPE.REMINDER_WHEN_AVAILABLE
  );
}

/** Same id the server sweeper writes, so open-app and closed-app pings dedupe. */
export function stableInboxItemId({ type, campaignId, missionId, reminderId, occurrenceAt }) {
  if (type === NOTIFICATION_TYPE.REMINDER_AT_TIME && reminderId) {
    const base = `reminder_at_time:${campaignId}:${reminderId}`;
    return occurrenceAt ? `${base}:${occurrenceAt}` : base;
  }
  if (type === NOTIFICATION_TYPE.WAIT_FOR && reminderId) {
    const base = `wait_for:${campaignId}:${reminderId}`;
    return occurrenceAt ? `${base}:${occurrenceAt}` : base;
  }
  if (isAvailableEvent(type)) {
    return `mission_available:${campaignId}:${missionId}`;
  }
  return `${type || 'ping'}:${campaignId}:${missionId}`;
}
